<template>
	<div style="min-height: 75vh">


		<div class="px-2 mb-sm-0">
			<OffersDashboardControls class="offers-dashboard-controls"></OffersDashboardControls>
		</div>





		<div class="offers-list__container" v-if="!loadingOffers">
			<RectangleOfferTile :offer="offer" @click="offerTileClicked(offer)" v-for="offer in offerStore.offers"
				:key="offer.id"></RectangleOfferTile>
		</div>




		<div v-if="loadingOffers" class="offers-list__container">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 20" :key="n"
				color="var(--v-skeleton-loader-color)">
			</v-skeleton-loader>
		</div>



		<EmptyList class="mx-auto mt-4" v-if="offerStore.offers.length === 0 && !loadingOffers">
			<template v-slot:title>
				Sorry, you haven't withdrawn any rewards yet.
			</template>
		</EmptyList>



		<Pagination 
			:model-value="pageNumber"
			@update:model-value="(value) => pageNumber = value"
			:length="pageLength" 
			:total-visible="totalVisible"
		/>




		<OfferDetailsDialog :offer="selectedOffer" @report-offer="openReportOfferDialog" />




		<ReportOfferDialog />




		<FloatingActionButton v-if="isMobileDevice"/>




	</div>
</template>





<script setup>

import { useDisplay } from "vuetify";
import { isMobile } from "@/utils/utils";
import { OfferStore } from "@/store/offerStore";
import { ref, computed, provide } from "vue";
import EmptyList from "@/components/Common/Empty-List.vue";
import Pagination from "@/components/Common/Pagination.vue";
import FloatingActionButton from "@/components/Offer/Floating-Action-Button.vue";
import RectangleOfferTile from "@/components/Tiles/Offer/Rectangle-Offer-Tile.vue";
import OffersDashboardControls from "@/components/Offer/Offers-Dashboard-Controls.vue";
import OfferDetailsDialog from "@/components/Offer/StartOfferDialogComponents/Offer-Details-Dialog.vue";
import ReportOfferDialog from "@/components/Offer/StartOfferDialogComponents/Report-Offer-Dialog.vue";
import { usePagination } from "@/composables/usePagination";

const offerStore = OfferStore();
const isMobileDevice = isMobile();
const loadingOffers = computed(() => offerStore.loadingOffers);
const selectedOffer = computed(() => offerStore.selectedOffer);

const offerDetailsDialogOpen = ref(false);
provide("offerDetailsDialogOpen", offerDetailsDialogOpen);

const reportOfferDialogOpen = ref(false);
provide("reportOfferDialogOpen", reportOfferDialogOpen);


// Use the pagination composable to handle pagination logic
const { pageNumber, pageLength, totalVisible } = usePagination({
	store: offerStore,
	getTotalPages: (store) => store.offersPaging.totalPages,
	getCurrentPage: (store) => store.offersPaging.page,
	setPage: (store, page) => store.setPage(page),
	fetchData: async (store) => await store.getOffers()
});

const offerTileClicked = (offer) => {
	offerStore.selectOffer(offer);
	offerDetailsDialogOpen.value = true;
};

// Use the composable to handle offer ID in the URL
import { useOfferFromUrl } from '@/composables/useOfferFromUrl';

// Pass the dialog ref to the composable
useOfferFromUrl(offerDetailsDialogOpen);

const openReportOfferDialog = () => {
	offerDetailsDialogOpen.value = false;
	reportOfferDialogOpen.value = true;
};

</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;

:deep(.v-btn--disabled > .v-btn__overlay) {
	background-color: black; // TODO: check this
}

.offers-dashboard-controls {
	z-index: 1;
	position: relative;
	top: -60px;
}

@media only screen and (max-width: vars.get-map-value(vars.$breakpoints, mobile)) {
	.offers-dashboard-controls {
		top: 0px;
	}
}

@media screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
	.offers-dashboard-controls {
		top: -40px;
	}
}
</style>
